"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeRequiredOption = void 0;
const immutable_1 = require("immutable");
const RequiredOption_1 = require("../entity/RequiredOption");
const requiredOptionItem_1 = require("./requiredOptionItem");
const createSomeRequiredOption = ({ name = 'フリーサイズ', amount = 1, points = immutable_1.List([
    requiredOptionItem_1.createRequiredOptionItem({ key: 'create', point: 80, rewardAmount: 15000, rewardCurrency: 'JPY' }),
    requiredOptionItem_1.createRequiredOptionItem({ key: 'resize', point: 40, rewardAmount: 10000, rewardCurrency: 'JPY' }),
    requiredOptionItem_1.createRequiredOptionItem({
        key: 'modificationRequestForCreate',
        point: 10,
        rewardAmount: 10000,
        rewardCurrency: 'JPY',
    }),
    requiredOptionItem_1.createRequiredOptionItem({
        key: 'modificationRequestForResize',
        point: 5,
        rewardAmount: 10000,
        rewardCurrency: 'JPY',
    }),
    requiredOptionItem_1.createRequiredOptionItem({ key: 'expressPerDayForCreate', point: 20, rewardAmount: 5000, rewardCurrency: 'JPY' }),
    requiredOptionItem_1.createRequiredOptionItem({ key: 'expressPerDayForResize', point: 10, rewardAmount: 5000, rewardCurrency: 'JPY' }),
]), } = {}) => new RequiredOption_1.default({ name, amount, points });
exports.createSomeRequiredOption = createSomeRequiredOption;
